













import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import Vue from 'vue';
import { RouteHelpers, FormFieldValidation, ModalHelpers } from '@/mixins';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import ArenaSignEditTemplateAfterSignMappings from '@/components/configuration/arenaSign/ArenaSignEditTemplateAfterSignMappings.vue';
import { Configuration, ArenaSignApi, RouteRegEx } from '@/types';

export default Vue.extend({
  name: 'DocuSignEditTemplateAfterSignMappings',
  mixins: [RouteHelpers, FormFieldValidation, ModalHelpers],
  data() {
    return {
      isLoading: true,
      hasError: false,
      errorMessage: '',
      docuSignTemplateAfterSignConfiguration: {},
      arenaSignApi: ArenaSignApi.DocuSign
    };
  },
  methods: {
    async getData(this: any) {
      // tslint:disable-next-line:max-line-length
      this.docuSignTemplateAfterSignConfiguration = await DocuSignConfigurationService.getTemplateAfterSignConfigurationAsync(
        parseInt(this.$route.params.id, 10)
      );
    },
    navigateToMappingsManagement(this: any) {
      this.$router.push({ name: Configuration.DocuSign.AfterSignMapping.Management.name });
    }
  },
  async mounted() {
    await this.getData();
    this.isLoading = false;
  },
  components: {
    LoadingSpinner,
    MStoreFormSelect,
    ArenaSignEditTemplateAfterSignMappings
  }
});
